export const sessionStorageAnalyticsKeys = {
  analytics: 'productsPageOpenSent',
  bloomreach: 'bloomreachProductsPageOpenSent',
};

export enum SearchResultCardCashbackPriceClickSource {
  RESULTS = 'results',
  HOT_OFFERS = 'hot_offers',
  SPECIAL_OFFERS = 'special_offers',
  RECOMMENDED_OFFERS = 'recommended_offers',
}
